import { ReportComplianceData } from "../../models/interfaces/reports/report-compliance-data";
import { useTranslation } from 'react-i18next';
import ReportGenericHeader from "./report-generic-header";
const COMPONENT_CLASS = "c-report";

// -----------------------------------------------------------------------------------------
// #region Intefaces
// -----------------------------------------------------------------------------------------

interface ReportComplianceProps {
    data: ReportComplianceData;
}

// #endregion Intefaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const ReportCompliance: React.FC<ReportComplianceProps> = (
    props: ReportComplianceProps
) => {
    const { data } = props;
    const { t } = useTranslation();

    return (
        <div className={`${COMPONENT_CLASS} -compliance`}>
            <ReportGenericHeader companyName={data.organizationName} reportName={t('reports.compliance.reportName')} date={data.reportDate} />
            <div className="flex gap-6 pt-6 pb-6 px-10 sub-header" style={{ backgroundColor: "#F7F9FC" }}>
                <div className="w-1/3">
                    <p style={{ fontWeight: "500" }}>{t('reports.usersInReport')}</p>
                    <p>{data.totalUsers}</p>
                </div>
                <div className="w-1/3">
                    <p style={{ fontWeight: "500" }}>{t('reports.groups')}</p>
                    {data.groupNames && data.groupNames.length > 0 ?
                        <p>{data.groupNames.join(", ")}</p> :
                        <p>{data.organizationName}</p>
                    }
                </div>
                <div className="w-1/3">
                    <p style={{ fontWeight: "500" }}>{t('reports.tags')}</p>
                    {data.tagNames && data.tagNames.length > 0 &&
                        <p>{data.tagNames.join(", ")}</p>
                    }
                </div>

            </div>
            <div
                className={`${COMPONENT_CLASS}__statuses ${COMPONENT_CLASS}__section`}
            >
                <h2>{t('reports.compliance.overallStatus')}</h2>
                <div className={`${COMPONENT_CLASS}__statuses__wrapper`}>
                    <div className={`${COMPONENT_CLASS}__statuses__item `}>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__count`}
                        >
                            {((data.usersAssessment / data.totalUsers) * 100).toFixed(0) + "%" || t('general.notApplicable')}
                        </div>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__name`}
                        >
                            {t('reports.compliance.completedAssessment')}
                        </div>
                    </div>
                    <div className={`${COMPONENT_CLASS}__statuses__item `}>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__count`}
                        >
                            {data.usersAssessment || t('general.notApplicable')}
                        </div>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__name`}
                        >
                            {t('reports.compliance.completedAssessments')}
                        </div>
                    </div>
                    <div className={`${COMPONENT_CLASS}__statuses__item `}>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__count`}
                        >
                            {data.pendingAssessmentUsers.length || t('general.notApplicable')}
                        </div>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__name`}
                        >
                            {t('reports.compliance.pendingAssessments')}
                        </div>
                    </div>
                    <div className={`${COMPONENT_CLASS}__statuses__item `}>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__count`}
                        >
                            {data.pendingUsers || t('general.notApplicable')}
                        </div>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__name uppercase`}
                        >
                            {t('reports.compliance.pendingAccountCreation')}
                        </div>
                    </div>
                    <div className={`${COMPONENT_CLASS}__statuses__item `}>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__count`}
                        >
                            {data.pendingRetest.length || t('general.notApplicable')}
                        </div>
                        <div
                            className={`${COMPONENT_CLASS}__statuses__item__name uppercase`}
                        >
                            {t('reports.compliance.pendingRetest')}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`${COMPONENT_CLASS}__user-list ${COMPONENT_CLASS}__section`}
            >
                <h2>{t('reports.compliance.pendingAccountCreation')}</h2>
                <div className={`${COMPONENT_CLASS}__user-list__wrapper`}>
                    {data.pendingLoginUsers.map((email, index) => (
                        <ul
                            className={`${COMPONENT_CLASS}__user-list__item`}
                            key={`pending-${index}`}
                        >
                            <li className="email">{email}</li>
                        </ul>
                    ))}
                </div>
            </div>
            <hr />
            <div
                className={`${COMPONENT_CLASS}__user-list ${COMPONENT_CLASS}__section`}
            >
                <h2>{t('reports.compliance.pendingAssessment')}</h2>
                <div className={`${COMPONENT_CLASS}__user-list__wrapper pending-users-content`}>
                    {data.pendingAssessmentUsers.map((name, index) => (
                        <ul
                            className={`${COMPONENT_CLASS}__user-list__item`}
                            key={`user-assessment-${index}`}
                        >
                            <li className="email">{name}</li>
                        </ul>
                    ))}
                </div>
            </div>
            <hr />
            <div
                className={`${COMPONENT_CLASS}__user-list ${COMPONENT_CLASS}__section`}
            >
                <h2>{t('reports.compliance.pendingRetest')}</h2>
                <div className={`${COMPONENT_CLASS}__user-list__wrapper pending-users-content`}>
                    {data.pendingRetest.map((email, index) => (
                        <ul
                            className={`${COMPONENT_CLASS}__user-list__item`}
                            key={`pending-${index}`}
                        >
                            <li className="email">{email}</li>
                        </ul>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReportCompliance;
